import _ from 'lodash';

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
	
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    
    return null;
}

export const track = (eventName, props = {}) => {
    if (!window.analytics) {
        return;
    }
    
    const refsCookie = readCookie('_ggr');
    
    if (refsCookie) {
        try {
            props = _.extend(props, JSON.parse(refsCookie));
        } catch(err) {
            console.error('Could not parse refs cookie: ' + err.message);
        }
    }

    window.analytics.track(eventName, props);
};



/** WEBPACK FOOTER **
 ** ./src/track.js
 **/